import React, { useEffect, useState } from 'react';
import WorkingHours from 'components/working-hours';
import useNewBrandContext from 'contexts/new-brand.context';

const CreateBrandOpeningTime = () => {
  const { createBrandForm, setCreateBrandForm } = useNewBrandContext();
  const { brand_working_hours } = createBrandForm;
  const [workingHours, setWorkingHours] = useState(brand_working_hours);
  useEffect(() => {
    const updatedBrandWorkingHours = brand_working_hours?.map((brandHour: any) => {
      const matchingWorkHour = workingHours.find(
        (workHour: any) => workHour.name === brandHour.name
      );
      if (matchingWorkHour) {
        return {
          ...brandHour,
          opening_time: matchingWorkHour.opening_time,
          closing_time: matchingWorkHour.closing_time,
          active: matchingWorkHour.active
        };
      }

      return brandHour;
    });

    setCreateBrandForm({ ...createBrandForm, brand_working_hours: updatedBrandWorkingHours });
  }, [workingHours]);
  return <WorkingHours data={workingHours} setData={setWorkingHours} />;
};

export default CreateBrandOpeningTime;
